<template>
  <div class="location-search">
    <div class="location-search__header">
      <label :for="labelId" :class="{ 'is-sr-only': hideLabel }">Location<sup>*</sup></label>
    </div>
    <input
      ref="locInput"
      required
      :id="labelId"
      type="text"
      name="location"
      :aria-label="placeholder"
      :placeholder="placeholder"
      class="input is-grey-dark"
      v-model="searchTerm"
      @keydown.enter.prevent.self
    />
  </div>
</template>

<script>
import { debounce } from '@/utils';
import axios from 'axios';

const debounced = debounce(300);

export default {
  name: 'GoogleLocationSearch',
  props: {
    hideLabel: {
      type: Boolean,
      default: false,
    },
    labelId: {
      type: String,
      required: true,
    },
    placeholder: String,
  },
  emits: ['maps-loaded', 'update-location'],
  mounted() {
    // Watch for google loaded
    const checkingInterval = setInterval(() => {
      if (window.google) {
        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.locInput, {
          types: ['locality'],
          componentRestrictions: { country: 'au' },
          fields: ['address_components', 'formatted_address'],
        });
        this.autocomplete.addListener('place_changed', this.autoCompleteListener);
        clearInterval(checkingInterval);
        this.$emit('maps-loaded');
      }
    }, 10);
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  methods: {
    /**
     * Get predictions from Google Places API
     */

    autoCompleteListener() {
      const place = this.autocomplete.getPlace();

      // This may not necessarily be an error
      if (!place) {
        return;
      }

      // Suburb
      let suburb = place.address_components?.find((addr_comp) =>
        addr_comp.types.includes('locality'),
      );
      if (!suburb) {
        suburb = place.address_components?.find((addr_comp) =>
          addr_comp.types.includes('administrative_area_level_2'),
        );
      }

      // State
      const state = place.address_components?.find((addr_comp) =>
        addr_comp.types.includes('administrative_area_level_1'),
      );

      // Format calling components expect
      const search_term = suburb && state ? `${suburb.short_name}, ${state.short_name}` : '';

      this.searchTerm = search_term;
      this.$emit('update-location', search_term);
    },
  },
};
</script>
